import variables from "@/utils/variables";

export default function formatStatus(v) {
  for (let t of variables.orderStatus) {
    if (v == t.value) {
      return t.text;
    }
  }

  return;
}
